import axios from 'axios';
import { baseUrl, isTokenValid, token } from '../../../services/Apis';

export const USUARIOS_CONST = 'usuarios';
export const INFORMACION_CONST = 'perfil';

export const usuariosApi = `${baseUrl}/${USUARIOS_CONST}`;
export const informacionApi = `${baseUrl}/${INFORMACION_CONST}`;

export const allUsuariosService = async (params) => {
  try {
    const res = await axios.get(usuariosApi, {
      headers: token({}),
      params,
    });
    return res;
  } catch (e) {
    isTokenValid(e);
    return e.response;
  }
};

export const getSearchUsuariosService = async (params) => {
  try {
    const res = await axios.get(`${usuariosApi}/search`, {
      headers: token({}),
      params,
    });
    return res;
  } catch (e) {
    isTokenValid(e);
    return e.response;
  }
};

export const getEntidadesService = async (id) => {
  try {
    const res = await axios.get(`${usuariosApi}/${id}/entidades`, {
      headers: token({}),
    });
    return res;
  } catch (e) {
    isTokenValid(e);
    return e.response;
  }
};

export const saveUsuariosService = async (data) => {
  const res = await axios.post(usuariosApi, data, {
    headers: token({}),
  });
  return res;
};

export const updateUsuariosService = async (id, data) => {
  const res = await axios.patch(`${usuariosApi}/${id}`, data, {
    headers: token({}),
  });
  return res;
};

export const oneUsuariosService = async (id) => {
  const res = await axios.get(`${usuariosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteUsuariosService = async (id) => {
  const res = await axios.delete(`${baseUrl}/${USUARIOS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const updatePerfilUsuariosService = async (id, data) => {
  const res = await axios.patch(`${informacionApi}/${id}`, data, {
    headers: token({}),
  });
  return res;
};

export const sincronizarUsuariosService = async (params) => {
  try {
    const res = await axios.get(`${usuariosApi}/sincronizar`, {
      headers: token({}),
      params,
    });
    return res;
  } catch (e) {
    isTokenValid(e);
    return e.response;
  }
};
